import { render, staticRenderFns } from "./BriqPlanboard.vue?vue&type=template&id=897ff1f0&lang=pug&"
import script from "./BriqPlanboard.vue?vue&type=script&lang=js&"
export * from "./BriqPlanboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports